import { getItemMaker } from "./tools";

const i = getItemMaker("cards");
export const cards = [
  i("Green Mushroom Card"),
  i("Red Mushroom Card"),
  i("Frog Card"),
  i("Bored Bean Card"),
  i("Slime Card"),
  i("Baby Boa Card"),
  i("Carrotman Card"),
  i("Glublin Card"),
  i("Wode Board Card"),
  i("Gigafrog Card"),
  i("Poop Card"),
  i("Rat Card"),
  i("Walking Stick Card"),
  i("Nutto Card"),
  i("Crystal Carrot Card"),
  i("Wood Mushroom Card"),

  i("Sandy Pot Card"),
  i("Mimic Card"),
  i("Crabcake Card"),
  i("Mafioso Card"),
  i("Sand Castle Card"),
  i("Pincermin Card"),
  i("Mashed Potato Card"),
  i("Tyson Card"),
  i("Moonmoon Card"),
  i("Sand Giant Card"),
  i("Snelbie Card"),
  i("Dig Doug Card"),
  i("Crystal Crabal Card"),
  i("Bandit Bob Card"),

  i("Copper Ore Card"),
  i("Iron Ore Card"),
  i("Gold Ore Card"),
  i("Fire Forge Card"),
  i("Oak Logs Card"),
  i("Bleach Logs Card"),
  i("Jungle Logs Card"),
  i("Forest Fibres Card"),
  i("Goldfish Card"),
  i("Hermit Can Card"),
  i("Jellyfish Card"),
  i("Fly Card"),
  i("Butterfly Card"),

  i("Platinum Ore Card"),
  i("Dementia Ore Card"),
  i("Void Ore Card"),
  i("Cinder Forge Card"),
  i("Tropilogs Card"),
  i("Potty Rolls Card"),
  i("Veiny Logs Card"),
  i("Bloach Card"),
  i("Sentient Cereal Card"),
  i("Fruitfly Card"),
  i("Forest Soul Card"),
  i("Dune Soul Card"),
  i("Froge Card"),
  i("Crabbo Card"),
  i("Scorpie Card"),

  i("Sheepie Card"),
  i("Frost Flake Card"),
  i("Sir Stache Card"),
  i("Bloque Card"),
  i("Mamooth Card"),
  i("Snowman Card"),
  i("Penguin Card"),
  i("Thermister Card"),
  i("Quenchie Card"),
  i("Cryosnake Card"),
  i("Bop Box Card"),
  i("Neyeptune Card"),
  i("Dedotated Ram Card"),
  i("Xylobone Card"),
  i("Bloodbone Card"),
  i("Crystal Cattle Card"),

  i("Lustre Ore Card"),
  i("Starfire Ore Card"),
  i("Dreadlo Ore Card"),
  i("Godshard Ore Card"),
  i("Tundra Logs Card"),
  i("Wispy Lumber Card"),
  i("Alien Hive Chunk Card"),
  i("Cubed Logs Card"),
  i("Maple Logs Card"),
  i("Dandielogs Card"),
  i("Bamboo Logs Card"),
  i("Effervescent Logs Card"),
  i("Skelefish Card"),
  i("Sand Shark Card"),
  i("Manta Ray Card"),
  i("Kraken Card"),
  i("Mosquisnow Card"),
  i("Flycicle Card"),
  i("Worker Bee Card"),
  i("Fairy Card"),
  i("Scarab Card"),
  i("Dust Mote Card"),
  i("Ladybug Card"),
  i("Firefly Card"),
  i("Mousey Card"),
  i("Owlio Card"),
  i("Pingy Card"),
  i("Bunny Card"),
  i("Dung Beat Card"),
  i("Honker Card"),
  i("Blobfish Card"),
  i("Rooted Soul Card"),
  i("Frigid Soul Card"),
  i("Squishy Soul Card"),
  i("Oozie Soul Card"),
  i("Breezy Soul Card"),
  i("Icefish Card"),
  i("Shellfish Card"),
  i("Jumbo Shrimp Card"),
  i("Caulifish Card"),

  i("Purp Mushroom Card"),
  i("TV Card"),
  i("Donut Card"),
  i("Demon Genie Card"),
  i("Soda Can Card"),
  i("Flying Worm Card"),
  i("Gelatinous Cuboid Card"),
  i("Choccie Card"),
  i("Biggole Wurm Card"),
  i("Clammie Card"),
  i("Octodar Card"),
  i("Flombeige Card"),
  i("Stilted Seeker Card"),
  i("Crystal Custard Card"),
  i("Suggma Card"),
  i("Maccie Card"),
  i("Mister Brightside Card"),
  i("Cheese Nub Card"),
  i("Stiltmole Card"),
  i("Molti Card"),
  i("Purgatory Stalker Card"),
  i("Citringe Card"),
  i("Lampar Card"),
  i("Fire Spirit Card"),
  i("Biggole Mole Card"),
  i("Crawler Card"),
  i("Tremor Wurm Card"),
  i("Crystal Capybara Card"),

  i("Sprout Spirit Card"),
  i("Ricecake Card"),
  i("River Spirit Card"),
  i("Baby Troll Card"),
  i("Woodlin Spirit Card"),
  i("Bamboo Spirit Card"),
  i("Lantern Spirit Card"),
  i("Mama Troll Card"),
  i("Leek Spirit Card"),
  i("Ceramic Spirit Card"),
  i("Skydoggie Spirit Card"),
  i("Royal Egg Card"),
  i("Minichief Spirit Card"),
  i("Samurai Guardian Card"),
  i("Crystal Candalight Card"),

  i("Poisonic Frog Card"),
  i("Globohopper Card"),
  i("King Frog Card"),
  i("Lava Slimer Card"),
  i("Chromatium Frog Card"),
  i("Eldritch Croaker Card"),
  i("Grandfrogger Card"),
  i("Rotting Grandfrogger Card"),
  i("Forlorn Grandfrogger Card"),
  i("Vengeful Grandfrogger Card"),
  i("Target Card"),
  i("Grumblo Card"),
  i("Beefie Card"),
  i("Lazlo Card"),
  i("Cactopunk Card"),
  i("Crescent Spud Card"),
  i("Snakenhotep Card"),
  i("Enraged Snakenhotep Card"),
  i("Inevitable Snakenhotep Card"),
  i("Ice Guard Card"),
  i("Glaciaxus Card"),
  i("Golden Glaciaxus Card"),
  i("Caustic Glaciaxus Card"),

  i("Baba Yaga Card"),
  i("Dr Defecaus Card"),
  i("Boop Card"),
  i("Amarok Card"),
  i("Chaotic Amarok Card"),
  i("Radiant Amarok Card"),
  i("Biggie Hours Card"),
  i("King Doot Card"),
  i("Efaunt Card"),
  i("Chaotic Efaunt Card"),
  i("Gilded Efaunt Card"),
  i("Dilapidated Slush Card"),
  i("Chizoar Card"),
  i("Chaotic Chizoar Card"),
  i("Blighted Chizoar Card"),
  i("Mutated Mush Card"),
  i("Massive Troll Card"),
  i("Chaotic Troll Card"),
  i("Blitzkrieg Troll Card"),
  i("Domeo Magmus Card"),
  i("Kattlekruk Card"),
  i("Chaotic Kattlekruk Card"),
  i("Sacrilegious Kattlekruk Card"),
  i("Demented Spiritlord Card"),
  i("Emperor Card"),
  i("Chaotic Emperor Card"),
  i("Sovereign Emperor Card"),

  i("Ghost (Event) Card"),
  i("Giftmas Blobulyte Card"),
  i("Meaning of Giftmas Card"),
  i("Valentslime Card"),
  i("Loveulyte Card"),
  i("Chocco Box Card"),
  i("Giant Rose Card"),
  i("Floofie Card"),
  i("Shell Snake Card"),
  i("Egggulyte Card"),
  i("Egg Capsule Card"),
  i("Plasti Doug Card"),
  i("Mr Blueberry Card"),
  i("Coastiolyte Card"),
  i("Summer Spirit Card"),
  i("Golden Giftmas Box Card"),
  i("Bubbulyte Card"),
  i("Spring Splendor Card"),
  i("Falloween Pumpkin Card"),
];
